<div class="header-container fxflex fxcenterstart">
  <div class="header fxcolumn">
    <div class="fxrow fxspacecenter">
      <div class="left-container">
        <img
          alt="logo"
          class="logo-icon clickable"
          src="/assets/svg/rts-ai-content-assistant-black.svg"
          (click)="logoClicked($event)"
        />
        <app-select-organization
          [organizations]="userOrganizations$ | async"
          [selectedOrganizationId]="selectedOrganizationId$ | async"
          [allowAddingOrganization]="isSuperAdminOrSupport$ | async"
          (organizationSelected)="onOrganizationSelected($event)"
          (addOrganization)="onAddOrganization()"
        />
      </div>

      <div class="right-container fxrow fxspacecenter">
        <rtr-icon-button
          icon="help-sm"
          type="plain"
          class="header-icon"
          shape="circle"
          [matMenuTriggerFor]="helpMenu"
        />
        <rtr-icon-button type="plain" icon="profile-sm" class="header-icon user-profile-icon" (click)="editProfile()" />
        <rtr-button
          type="tertiary"
          [text]="unselectedLanguage$ | async | uppercase"
          class="language-picker"
          (click)="changeLanguage()"
        />
        <rtr-button type="tertiary" text="Layout.Logout" dataCy="logout-button" class="logout" (click)="logoutUser()" />
      </div>
    </div>
    <app-header-navigation [routes]="userRoutes$ | async" (navigate)="onNavigate($event)" />
  </div>
</div>

<mat-menu #helpMenu>
  @for (item of helpMenuItems; track item.id) {
    <button class="help-menu-item" mat-menu-item [disableRipple]="true" (click)="helpMenuItemClicked(item)">
      {{ item.label | translate }}
    </button>
  }
</mat-menu>
